export var DEFAULT_HIDE_DELAY = 3000;
export var DEFAULT_MAX_TOASTS_NUMBER = 3;
export var DEFAULT_MAX_TOASTS_NUMBER_MOBILE = 1;
export var DEFAULT_PLACEMENT_DESKTOP = 'bottom-right';
export var DEFAULT_PLACEMENT_MOBILE = 'bottom-center';
export var hidableToasts = ['success', 'error', 'info'];